const src = import.meta.ROLLUP_FILE_URL_AsHNVVn_Y92mmWEtoBC9VA;
export default {
  src,
  srcSet: src + " " + 420 + "w",
  width: 420,
  height: 280,
};